/**
 * Profile photo (#579): the checks a picked file must pass before it is sent.
 *
 * The same rules as the backend (`@shared/constants/avatar`), applied first here
 * so an oversized or unsupported file is refused on the spot with a clear
 * message rather than after an upload. The server re-checks the decoded image.
 *
 * Pure (no React, no fetch).
 */
import { AVATAR_MAX_BYTES, AVATAR_MIME_TYPES } from '@shared/constants/avatar';

/** What the picker reads of a `File`. */
export interface PickedFile {
  type: string;
  size: number;
}

/** The `accept` attribute of the file input. */
export const AVATAR_ACCEPT = AVATAR_MIME_TYPES.join(',');

/** The hint shown under the photo. */
export const AVATAR_HINT = 'JPEG, PNG or WebP, 5 MB max.';

const ACCEPTED: readonly string[] = AVATAR_MIME_TYPES;

/** Why the file cannot be used as a photo, or `null` when it can. */
export function avatarFileProblem(file: PickedFile): string | null {
  if (!ACCEPTED.includes(file.type)) return 'The photo must be a JPEG, PNG or WebP image.';
  if (file.size > AVATAR_MAX_BYTES) return 'The photo must not exceed 5 MB.';
  return null;
}
